<template>
  <div class="image-upload">
    <img
      v-if="editUrl && !uploadEnd && !uploading"
      :src="editUrl"
      width="100%"
    />
    <img v-if="uploadEnd" :src="downloadURL" width="100%" />
    <v-btn v-if="!uploadEnd && !uploading" block @click.native="selectFile">
      <span v-if="editUrl && !uploadEnd">Change image</span>
      <span v-else>Upload image</span>
      <v-icon right aria-hidden="true"> add_photo_alternate </v-icon>
    </v-btn>
    <input
      id="files"
      ref="uploadInput"
      type="file"
      name="file"
      accept="image/*"
      :multiple="false"
      @change="detectFiles($event)"
    />
    <v-progress-circular
      v-if="uploading && !uploadEnd"
      :size="100"
      :width="15"
      :rotate="360"
      :value="progressUpload"
      color="info"
    >
      {{ progressUpload }}%
    </v-progress-circular>
    <div v-if="uploadEnd">
      <v-btn class="ma-0" dark small color="error" @click="deleteImage()">
        Delete
      </v-btn>
    </div>
  </div>
</template>

<script>
import { storage } from '@/firebaseConfig';

export default {
  name: 'UploadImage',
  props: {
    editUrl: {
      type: String,
      default: null
    },
    dimensions: {
      type: Array,
      default: null
    },
    minDimensions: {
      type: Array,
      default: null
    },
    maxFileSize: {
      type: Number,
      default: null
    },
    path: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      progressUpload: 0,
      fileName: '',
      uploadTask: null,
      uploading: false,
      uploadEnd: false,
      downloadURL: ''
    };
  },
  watch: {
    uploadTask: function(val) {
      if (val) {
        this.uploadTask.on(
          'state_changed',
          sp => {
            this.progressUpload = Math.floor(
              (sp.bytesTransferred / sp.totalBytes) * 100
            );
          },
          null,
          () => {
            this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              this.uploadEnd = true;
              this.downloadURL = downloadURL;
              this.$emit('downloadpath', {
                path: this.uploadTask.location_.path_,
                url: downloadURL
              });
            });
          }
        );
      }
    }
  },
  methods: {
    reset() {
      this.progressUpload = 0;
      this.uploading = false;
      this.uploadEnd = false;
      this.uploadTask = null;
      this.fileName = false;
      this.downloadURL = '';
      this.$emit('downloadpath');
      this.$refs.uploadInput.value = null;
    },
    selectFile() {
      this.$refs.uploadInput.click();
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files;
      Array.from(Array(fileList.length).keys()).map(x => {
        this.upload(fileList[x]);
      });
    },
    upload(file) {
      let fileSize = file.size;
      let width;
      let height;

      let reader = new FileReader();
      reader.onloadend = e => {
        let image = new Image();
        image.src = e.target.result;

        image.onload = () => {
          width = image.width;
          height = image.height;

          if (this.maxFileSize && fileSize > this.maxFileSize) {
            this.$store.dispatch('createSnackbar', {
              color: 'error',
              text: `File must not be larger than ${this.maxFileSize / 1000}KB`
            });
            this.reset();
          } else if (
            this.dimensions &&
            width !== this.dimensions[0] &&
            height !== this.dimensions[1]
          ) {
            this.$store.dispatch('createSnackbar', {
              color: 'error',
              text: `Image dimensions must be exactly ${
                this.dimensions[0]
              }px * ${this.dimensions[1]}px`
            });
            this.reset();
          } else if (
            this.minDimensions &&
            width < this.minDimensions[0] &&
            height < this.minDimensions[1]
          ) {
            this.$store.dispatch('createSnackbar', {
              color: 'error',
              text: `Image dimensions must be at least ${
                this.minDimensions[0]
              }px * ${this.minDimensions[1]}px`
            });
            this.reset();
          } else {
            this.fileName = file.name;
            this.uploading = true;
            this.uploadTask = storage
              .ref(this.path + '/' + file.name)
              .put(file);
          }
        };
      };
      reader.readAsDataURL(file);
    },
    deleteImage() {
      storage
        .ref(this.path + '/' + this.fileName)
        .delete()
        .then(() => {
          this.reset();
        })
        .catch(error => {
          alert(`Image delete error occured: ${error}`);
        });
    }
  }
};
</script>

<style lang="scss">
.v-btn {
  margin-top: 0;
  margin-bottom: 0;
}
.progress-bar {
  margin: 10px auto;
}
.image-upload {
  position: relative;
  img {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: auto;
  }
  input[type='file'] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    top: 0;
    width: 0;
    height: 0;
  }
}
</style>
